
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rivenditori/[slug_regione]/[slug_provincia]/[slug_citta]",
      function () {
        return require("private-next-pages/rivenditori/[slug_regione]/[slug_provincia]/[slug_citta]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rivenditori/[slug_regione]/[slug_provincia]/[slug_citta]"])
      });
    }
  